<template>
  <div class="columns">
    <div class="column">
      <b-field :label="contact.name ? 'Nome' : ''" label-position="on-border">
        <b-input v-model="contact.name" expanded placeholder="Nome"></b-input>
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="contact.email ? 'E-mail pessoal' : ''"
        label-position="on-border"
      >
        <b-input
          v-model="contact.email"
          expanded
          placeholder="E-mail pessoal"
        ></b-input>

        <button class="button" type="button" @click="$emit('add-contact')">
          +
        </button>

        <button
          class="button"
          type="button"
          @click="$emit('remove-contact', index)"
        >
          -
        </button>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contact", "index"]
};
</script>
